import styled from 'styled-components';

import { COLORS } from 'constants/colors';
import { FONTS, FONTS_WEIGHT } from 'constants/fonts';

export const BodyContainer = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
  margin-left: 16px;
  margin-right: 16px;
  padding-bottom: 25px;
`;
export const PollContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const VoteDetails = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  font-size: ${FONTS.TEXT_FONT};
  font-weight: ${FONTS_WEIGHT.TEXT_REGULAR};
  line-height: 20px;
  color: ${COLORS.colorTextDropDown};
`;
